<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="columns columns--full is-vcentered">
    <div class="column has-text-centered onboarding-create-site__description">
      <transition appear name="slide-fade" mode="in-out">
        <h1 class="onboarding-create-site__title">
          Estamos finalizando os últimos detalhes
        </h1>
      </transition>
    </div>
  </div>
</template>

<script>
import verifyOnboardingCompleteMixin from '@/mixins/verifyOnboardingCompleteMixin'
import Onboarding from '@/lib/api/Onboarding.js'

export default {
  mixins: [verifyOnboardingCompleteMixin],

  mounted() {
    setTimeout(this.nextStep, 3000)
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
    answerUser() {
      return this.$store.state.onboardingCreateSite.answersOfStep
    },
    onboarding_complete: {
      get() {
        return this.$store.state.onboardingCreateSite.onboarding_complete
      },

      set(payload) {
        this.$store.dispatch('setOnboardingComplete', payload)
      },
    },
  },

  methods: {
    nextStep() {
      let answersOnboarding = JSON.parse(
        localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
      )

      // User jump all steps
      !answersOnboarding
        ? this.$router.push({
            path: '/onboarding/passo-11',
          })
        : !answersOnboarding.onboarding_complete
        ? this.saveDataOnboarding(answersOnboarding)
        : ''
    },

    async saveDataOnboarding(data) {
      data.wed_id = this.logonToken.token_payload.wed_id

      const saveOnboarding = new Onboarding(this.logonToken)
      const response = await saveOnboarding.saveOnboarding(data)
      const result = response

      if (result) {
        data.onboarding_complete = true

        // set Vuex
        this.onboarding_complete = true
        // set localStorage
        localStorage.setItem(
          `onboarding_wed${this.answerUser.wed_id}`,
          JSON.stringify(data)
        )

        this.$router.push({
          path: '/onboarding/passo-11',
        })
      } else {
        this.$router.push({
          path: '/onboarding/configurar-novamente',
        })
      }
    },
  },
}
</script>

<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(2, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(20px);
  opacity: 0;
}
</style>
